import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import { paths } from 'src/routes/paths';

import { useBoolean } from 'src/hooks/use-boolean';

import Main from '../main';
import Header from '../header';
import NavVertical from './nav-vertical';
import { useNavData } from './config-navigation';

// ----------------------------------------------------------------------

export default function DiagRefDashboardLayout({ children }) {
  const nav = useBoolean();
  const navData = useNavData();

  const renderNavVertical = (
    <NavVertical
      openNav={nav.value}
      onCloseNav={nav.onFalse}
      navData={navData}
      itemHref={paths.entity.modules.diag_ref.dashboard.root}
    />
  );

  const renderContent = () => (
    <>
      <Header onOpenNav={nav.onTrue} />

      <Box
        sx={{
          minHeight: 1,
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          flex: 1,
        }}
      >
        {renderNavVertical}

        <Main>{children}</Main>
      </Box>
    </>
  );

  return (
    <Box sx={{ minHeight: 1, display: 'flex', flexDirection: 'column' }}>{renderContent()}</Box>
  );
}

DiagRefDashboardLayout.propTypes = {
  children: PropTypes.node,
};
